<template>
	<svg width="10px" height="5px" viewBox="0 0 10 5" version="1.1" xmlns="https://www.w3.org/2000/svg" xmlns:xlink="https://www.w3.org/1999/xlink">
	    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
	        <g transform="translate(-1332.000000, -18.000000)" fill="#EEEEEE">
	            <path d="M1335.24648,16.1084596 C1335.06756,15.8402149 1334.68985,15.7827339 1334.41154,15.9551769 C1334.13323,16.1276199 1334.07359,16.4916663 1334.2525,16.759911 C1334.27238,16.7982317 1334.31214,16.8365524 1334.33202,16.8557127 L1337.57238,20.4770163 L1334.33202,24.1558008 C1334.09347,24.3665645 1334.07359,24.7306109 1334.31214,24.9605349 C1334.53082,25.1904589 1334.90853,25.2096193 1335.14708,24.9796953 C1335.18684,24.9413746 1335.20672,24.9222142 1335.2266,24.8838936 L1339.14286,20.4578559 L1335.24648,16.1084596 Z" transform="translate(1336.642857, 20.500000) rotate(-270.000000) translate(-1336.642857, -20.500000) "></path>
	        </g>
	    </g>
	</svg>
</template>
<script>
export default { name: 'navbar-down-arrow-icon' }
</script>
